import { render, staticRenderFns } from "./DriveFolderCreated.vue?vue&type=template&id=62939210&scoped=true"
import script from "./DriveFolderCreated.vue?vue&type=script&lang=js"
export * from "./DriveFolderCreated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62939210",
  null
  
)

export default component.exports